import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';

import type { RootState } from '../../store/store';
import { hasAnyModuleAccess } from '../../utils/subscriptions';

const useFreemiumGuard = (allowedUrls: string[] = []) => {
  const location = useLocation();
  const company = useSelector((state: RootState) => state.auth.company);

  const isAllowedUrl = allowedUrls.some(pattern => 
    matchPath({ path: pattern, end: true }, location.pathname),
  );

  if (company && company.id && !hasAnyModuleAccess(company) && !isAllowedUrl) {
    return true;
  }

  if (company && !company.id && !isAllowedUrl) {
    // user is still loading, we don't want to block the page as no query will be done without company
    return false;
  }

  return false;
};

export default useFreemiumGuard;
